<div class="bubbles-container">
  <div 
    class="bubble" 
    *ngFor="let bubble of getBubbles(); trackBy: trackById"
    [style.bottom.%]="bubble.y"
    [style.left.%]="bubble.x"
    [style.width.px]="bubble.radius * 2"
    [style.height.px]="bubble.radius * 2"
  ></div>
</div> 